export const ConfigP1: GrafanaConf = [{ panelNumber: 18, height: 500 }];
export const ConfigP2: GrafanaConf = [
	{ panelNumber: 1, height: 500 },
	{ panelNumber: 17, height: 700 },
];
export const ConfigP3: GrafanaConf = [
	{ panelNumber: 16, height: 400 },
	{ panelNumber: 9, height: 400 },
	{ panelNumber: 10, height: 400 },
	{ panelNumber: 19, height: 400 },
];
type GrafanaConf = Array<{
	panelNumber: number;
	height: number;
	// periodicidad: "diario" | "mensual" | "anual";
}>;
